export default "__VITE_ASSET__BIHJWQ1R__"